import React, { ReactElement, useCallback, useMemo, useState } from 'react';

import { EvSwitch } from '@evinced-private/ui-common';

interface UseShowOnlyLastReportToggleReturn {
	showOnlyLastReport: boolean;
	showOnlyLastReportToggle: ReactElement;
}

export const useShowOnlyLastReportToggle = (): UseShowOnlyLastReportToggleReturn => {
	const [showOnlyLastReport, setShowOnlyLastReport] = useState<boolean>(false);

	const handleToggleChange = useCallback(() => {
		setShowOnlyLastReport(!showOnlyLastReport);
	}, [showOnlyLastReport]);

	const showOnlyLastReportToggle = useMemo(
		(): ReactElement => (
			<EvSwitch
				label="Show only the last report per test"
				checked={showOnlyLastReport}
				onChange={handleToggleChange}
			/>
		),
		[showOnlyLastReport, handleToggleChange]
	);

	return {
		showOnlyLastReport,
		showOnlyLastReportToggle
	};
};
